import { MARQUEE_ITEMS } from "../../data/site";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="marquee-section" className="relative py-7 border-y border-slate-100 bg-white overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-200 px-6">
              {item}
            </span>
            <span className="w-2.5 h-2.5 rounded-full bg-violet-300" />
          </span>
        ))}
      </div>
    </div>
  );
};
